import { Component } from "@angular/core";
import { BrowseSubjectsComponent } from "../../../shared/business/browse-subjects/browse-subjects.component";
import { StaticStudyToolsComponent } from "../../../shared/business/static-study-tools/static-study-tools.component";
import { StaticCardPaperComponent } from "../../../shared/business/static-card-paper/static-card-paper.component";
import { CoverStaticPaperComponent } from "../../../shared/UI/cover-static-paper/cover-static-paper.component";
import { WhyLovePaperComponent } from "../../../shared/UI/why-love-paper/why-love-paper.component";
import { ExploreToolsComponent } from "../../../shared/UI/explore-tools/explore-tools.component";

@Component({
  selector: "app-static-past-papers",
  imports: [
    // BrowseSubjectsComponent,
    // StaticStudyToolsComponent,
    StaticCardPaperComponent,
    CoverStaticPaperComponent,
    WhyLovePaperComponent,
    ExploreToolsComponent,
  ],
  templateUrl: "./static-past-papers.component.html",
  styleUrl: "./static-past-papers.component.css",
})
export class StaticPastPapersComponent {}
